import passEmpleado from "../api/empleado";
import apiErrorHandler from "../helpers/apiErrorHandler"; // Importa el helper

export const hashWithSHA1ToBase64UTF16 = async text => {
  const data = new Uint16Array(text.length);
  for (let i = 0; i < text.length; i++) {
    data[i] = text.charCodeAt(i);
  }

  const buffer = data.buffer;
  const hashBuffer = await crypto.subtle.digest("SHA-1", buffer);
  const hashBase64 = btoa(String.fromCharCode.apply(null, new Uint8Array(hashBuffer)));
  return hashBase64;
};

export const verificarEmpleado = async password => {
  try {
    console.log("🔐 Verificando contraseña:", password || "(vacía)");

    const resultado = await passEmpleado.getEmpleado();
    const empleados = resultado.data;

    console.log("👥 Empleados obtenidos:", empleados);

    // Para desarrollo: aceptar cualquier contraseña (incluso vacía)
    const empleadoEncontrado = empleados[0]; // Usar el primer empleado
    console.log("✅ Contraseña aceptada (modo desarrollo), empleado:", empleadoEncontrado.nombreEmpleado);
    return {
      success: true,
      empleado: empleadoEncontrado,
    };
  } catch (error) {
    console.error("❌ Error al obtener los empleados:", error);
    apiErrorHandler(error, { stopFlow: true });
    return {
      success: false,
      message: "Error al obtener los empleados",
    };
  }
};
